export default __webpack_public_path__ + "static/media/category3.75a05e2e.svg";